export default {
    apiKey: "AIzaSyAoR3HmGabKvf05gsPzn1aBqWaylWmBIn8",
    authDomain: "master-meal-planner.firebaseapp.com",
    databaseURL: "https://master-meal-planner.firebaseio.com",
    projectId: "master-meal-planner",
    storageBucket: "master-meal-planner.appspot.com",
    messagingSenderId: "716609677036"
}


